import { render } from "./UserPopover.vue?vue&type=template&id=6d3522d9"
import script from "./UserPopover.vue?vue&type=script&lang=js"
export * from "./UserPopover.vue?vue&type=script&lang=js"

import "./UserPopover.vue?vue&type=style&index=0&id=6d3522d9&lang=scss"
script.render = render

export default script